module.exports = __webpack_public_path__ + "img/Tessellate30.7ba0f2d1.jpg";